import { useEffect, useRef } from "react";
import { markHomeEnrichmentReviewedApi } from "../api/homeApi";
import { ENRICHMENT_REVIEW_FOCUS_STATE } from "../helper/homeEnrichmentFeed";

export function readReviewEntry(state) {
  if (!state || typeof state !== "object" || !state[ENRICHMENT_REVIEW_FOCUS_STATE]) return null;
  const executionId = String(state.enrichmentAttentionId || "").trim();
  if (!executionId) return null;
  return {
    executionId,
    focusColumnKey: state.focusEnrichmentColumn ? String(state.focusEnrichmentColumn) : null,
    markReviewed: state.markReviewed === true,
  };
}

/**
 * Arrival from Home's Review results (guide §5, Spec §6/§8, FE #700).
 *
 * Returns the run being restored (`executionId`, `focusColumnKey`) or null.
 * Only a Needs Attention review asks for `markReviewed`; then this calls
 * `POST /home/enrichments/{id}/reviewed` once (G8) so the run leaves Needs
 * Attention. That endpoint only stamps `reviewed_at`; this hook never
 * submits, quotes or re-runs an enrichment (R2). The entry is read once.
 */
export default function useHomeEnrichmentReviewEntry(locationState, restored = false) {
  const entryRef = useRef(undefined);
  if (entryRef.current === undefined) entryRef.current = readReviewEntry(locationState);
  const sentRef = useRef(false);

  useEffect(() => {
    const entry = entryRef.current;
    if (!restored || !entry?.markReviewed || sentRef.current) return;
    sentRef.current = true;
    markHomeEnrichmentReviewedApi(entry.executionId);
  }, [restored]);

  const entry = entryRef.current;
  return entry ? { executionId: entry.executionId, focusColumnKey: entry.focusColumnKey } : null;
}
